import { AttachmentContainer } from './styled';
import { FileType, ImageType } from '../types';
import Images from './Images';
import Documents from './Documents';

interface AttachmentProps {
  images: ImageType[];
  documents: FileType[];
  onSetImages: (images: ImageType[]) => void;
  onSetDocuments: (documents: FileType[]) => void;
}

const Attachment = ({
  images,
  documents,
  onSetImages,
  onSetDocuments,
}: AttachmentProps) => (
  <AttachmentContainer>
    <Images
      images={images}
      onSetImages={onSetImages}
    />
    <Documents
      documents={documents}
      onSetDocuments={onSetDocuments}
    />
  </AttachmentContainer>
);

export default Attachment;
